export default () => {
  return {
    searchOpen: false,
    sidebarOpen: false,
  }
}
